// ABOUTME: The inbounds TopRow totals cards, extracted as standalone presentational components so each can be
// ABOUTME: reused on the inbounds page and dropped individually into a BI dashboard cell.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import CallReceivedOutlinedIcon from "@mui/icons-material/CallReceivedOutlined";
import Text from "../../../../../components/theme/text/Text";
import Heading from "../../../../../components/theme/text/Heading";
import Subheading from "../../../../../components/theme/text/Subheading";
import ShDoubleTextSkeleton from "../../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import { tokens } from "../../../../../theme";

// The four cards key into one `useGetDashboardInboundTotalsQuery` payload by `type` (passed in as `data`).
export const inboundStates = {
    all: "",
    fullyreceived_today_count: "fullyreceived_today_count",
    shipment_today_count: "shipment_today_count",
    partlyreceived_count: "partlyreceived_count",
    shipment_next7days_count: "shipment_next7days_count"
}

// Generic totals card: shows data[type].label / data[type].value with a coloured logo chip.
export const RelationDashboardCard = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            component={"button"}
            // onClick={() => props.changeChartType(props.relationChartType)}
            className={cx('', {
                'active': props.active,
            })}
            sx={{
                flex: 1,
                flexShrink: 0,
                background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                border: "none",

                borderRadius: 4,
                padding: 3,
                display: "flex",
                // flexDirection:"column",

                ".logo-box": {
                    width: 40,
                    height: 40,
                    borderRadius: 2,
                    background: colors.pastel.light[props.color][100],
                    color: colors.txt["primary"],
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .logo": {
                        fill: colors.pastel.light[props.color][600],
                    }
                },

                // "&.active": {
                //     background: colors.pastel.light[props.color][100],
                //     ".logo-box" : {
                //         background: colors.pastel.light[props.color][200],
                //         "& .logo, & .logo path" : {
                //             fill: colors.pastel.light[props.color][600],
                //         }
                //     },
                // },
                "@media screen and (max-width: 47.9375em)": {
                    p: 2,
                    // flexDirection:"row",
                    // justifyContent:"space-between",
                    ".logo-box": {
                        width: 32,
                        height: 32,
                    }

                },
                ...props.sx,

            }}
        >
            <Box
                sx={{
                    // "@media screen and (max-width: 47.9375em)" : {
                    //     order:2
                    // }

                }}
            >
                <Box className="logo-box">
                    {props.logo}
                </Box>
            </Box>
            {props.isLoading ?
                <ShDoubleTextSkeleton />
                :
                <Box
                    sx={{
                        pl: 2,
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            "@media screen and (max-width: 47.9375em)": {
                                // pl:1,
                            }
                        }}
                    >
                        <Text light>{t(props.data ? props.data[props.type]?.label : "unknown")}</Text>
                        <Heading
                            className={cx('', {
                                'active': props.active
                            })}
                            sx={{
                                pt: 0.5,
                                // "&.active":{
                                //     color:`${colors.pastel.light[props.color][600]} !important`
                                // }
                            }}
                        >
                            {t(props.data ? props.data[props.type]?.value : "unknown")}
                        </Heading>
                    </Box>
                </Box>
            }
        </Box>
    )
}

// The whole inbounds "totals" box — all four cards together, as on the inbounds page TopRow. Inbounds is
// added/used as one totals unit, never card by card.
export const InboundsTotals = ({ data, isLoading, isFetching, sx }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const loading = isLoading || isFetching;
    const icon = <CallReceivedOutlinedIcon className="logo" />;

    return (
        <Box
            sx={{
                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                borderRadius: 4,
                p: 3,
                display: "flex",
                flexDirection: "column",
                ...sx,
            }}
        >
            <Box>
                <Subheading>{t("totals")}</Subheading>
            </Box>
            <Box sx={{ mt: 3, flex: 1, display: "flex", flexDirection: "column" }}>
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        borderBottom: `2px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                        pt: 1.5,
                        pb: 3,
                        gap: 3,
                    }}
                >
                    <RelationDashboardCard logo={icon} data={data} isLoading={loading} type={inboundStates.fullyreceived_today_count} color="lightblue" />
                    <RelationDashboardCard logo={icon} data={data} isLoading={loading} type={inboundStates.shipment_today_count} color="brown" />
                </Box>
                <Box sx={{ flex: 1, display: "flex", gap: 3, pt: 3 }}>
                    <RelationDashboardCard logo={icon} data={data} isLoading={loading} type={inboundStates.partlyreceived_count} color="green" />
                    <RelationDashboardCard logo={icon} data={data} isLoading={loading} type={inboundStates.shipment_next7days_count} color="pink" />
                </Box>
            </Box>
        </Box>
    );
};
